import DelegatedTokenManager from './DelegatedTokenManager';

class LoggerApiTokenManager extends DelegatedTokenManager {}

const loggerApiTokenManager = new LoggerApiTokenManager('logger');
export default loggerApiTokenManager;
